module.exports = __webpack_public_path__ + "img/biru.dfea3616.png";